import { action, mutator } from 'satcheljs';
import { mergeLocalizedStrings } from '../getLocalizedStrings';
import type { ResourceId } from '../ResourceId';
import type { LocalizedString } from '../LocalizedString';

export interface ADD_LOCSTRINGSActionMessage {
    str: Record<ResourceId, LocalizedString>;
}
export const addLocstringsToStore: (
    strings: Record<string, string>
) => ADD_LOCSTRINGSActionMessage = action(
    'ADD_LOCSTRINGS',
    (strings: Record<string, string>): ADD_LOCSTRINGSActionMessage => {
        return { str: strings as Record<ResourceId, LocalizedString> };
    }
);

mutator(addLocstringsToStore, ({ str }) => {
    mergeLocalizedStrings(str);
});
